import React from "react";
import { Stack } from "@mui/material";
import NewNavBar from "./shell-components/new-nav-bar";

const Shell = ({ children }) => {
  return (
    <Stack sx={{ margin: 0, padding: 0, width: '100%' }}>
      <Stack className="w-full" sx={{ margin: 0, padding: 0 }}>
        <NewNavBar />
        {children}
      </Stack>
    </Stack>
  );
};

export default Shell;
